<template>
  <article class="doc__content">
    <section class="section">
      <MultiAxesChartSample />
    </section>
  </article>
</template>

<script>
import MultiAxesChartSample from 'components/examples/MultiAxesChartSample'

export default {
  name: 'Home',
  components: {
    MultiAxesChartSample
  }
}
</script>
